import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../libs/AuthContext";

export default function AuthenticatedRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    const redirect = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?redirect=${encodeURIComponent(redirect)}`} replace />;
  }
  return <Outlet />;
}
